import { schema } from "normalizr";
import { arrayOfReminders } from "~/schemas/schema.reminders";
import { arrayOfDiscussions } from "./schema.discussions";
import { arrayOfNotes } from "./schema.notes";
import { arrayOfSubtasks } from "./schema.subtasks";
import { arrayOfTaskLists } from "./schema.task_lists";
import { arrayOfTasks } from "./schema.tasks";

const calendar = new schema.Entity("calendars");
const arrayOfCalendars = [calendar];
const calendarAssigments = {
  tasks: arrayOfTasks,
  subtasks: arrayOfSubtasks,
  task_lists: arrayOfTaskLists,
  reminders: arrayOfReminders,
  notes: arrayOfNotes,
  discussions: arrayOfDiscussions,
};

export { calendar, arrayOfCalendars, calendarAssigments };
